import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ae3de2f2c7105d343c2d3d6420c50b153b from "./generated-d2dfe320-9d27-47f6-9a8d-39dfc0f022cc.json";

import a8318742ee48c439d1a646fbff903b5b6b from "./generated-8989ca64-f43d-4ef0-969b-79bee57c020f.json";

import a9a7e953e52efc37c1b8baa1cb4e7de5fb from "./generated-b359ab39-c7fb-4d43-9b06-ad43dd5caf00.json";

import a232c73d3e4862ef2ab83d134400f9c5db from "./generated-340e5804-8f0f-4732-853a-b9da4e2ce1c1.json";

import a8beb3fcc38b1d6c94d934234de1aa03cb from "./generated-0f9ebb76-8445-45d5-86cb-432c6062a20a.json";

import a916dca6cfdb62649560711635740f597b from "./generated-dd6c8378-ec6c-4563-a7a8-127d442afc21.json";

import ab800e11cced34f454220f8d98a1a461eb from "./generated-39bd49dd-0e2e-4405-9ec5-d4fc2a324e02.json";

import a8c7d75e48d1ca87aeb09d9a1aab9be93b from "./generated-7269a920-09e1-4483-9202-1978bcb932a8.json";

import ace0aef5058c076b5fec4144ad886ca94b from "./generated-4a7b891c-52ef-4be8-8966-b3350477fe31.json";

import a6569f59069b0813fa662c0b261fdf531b from "./generated-c9b7e7be-9663-4e07-ac09-45c95c42d008.json";

import a285d6e1213648e515e4ae9d9d7aa682db from "./generated-6cc51aa0-2c30-412f-9501-3ce0eec16e8b.json";

import a8b2d7c096958a60885409dc9ab7d7c88b from "./generated-c8d9bd47-3352-43ea-bbb0-c9771903e102.json";

import a137f1a1a5de04d6b868ae1bcaa92d5a1b from "./generated-4cdf7280-9e98-4360-9387-eb4b3d9fb23b.json";

import a2b9815a142784061c24bdb0c037d3691b from "./generated-801fda0b-1e0a-4a99-af96-ee592f6db11e.json";

import a90872dbc3062aa1407378e32d3ca286db from "./generated-4b773723-f795-471d-b97e-6a7d6d518bc7.json";

import adf7a6f2c4b501b5148cb38a30b1ef55db from "./generated-53965493-1b3b-41f1-9629-79bc45fd153c.json";

import a501af149a8484da4db3094b3e6615705b from "./generated-51ca76e5-1a6e-49cb-8f8f-98e250df7b1d.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ae3de2f2c7105d343c2d3d6420c50b153b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a8318742ee48c439d1a646fbff903b5b6b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a9a7e953e52efc37c1b8baa1cb4e7de5fb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a232c73d3e4862ef2ab83d134400f9c5db);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a8beb3fcc38b1d6c94d934234de1aa03cb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a916dca6cfdb62649560711635740f597b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ab800e11cced34f454220f8d98a1a461eb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a8c7d75e48d1ca87aeb09d9a1aab9be93b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ace0aef5058c076b5fec4144ad886ca94b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a6569f59069b0813fa662c0b261fdf531b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a285d6e1213648e515e4ae9d9d7aa682db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a8b2d7c096958a60885409dc9ab7d7c88b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ace0aef5058c076b5fec4144ad886ca94b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a137f1a1a5de04d6b868ae1bcaa92d5a1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a2b9815a142784061c24bdb0c037d3691b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ace0aef5058c076b5fec4144ad886ca94b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a90872dbc3062aa1407378e32d3ca286db);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(adf7a6f2c4b501b5148cb38a30b1ef55db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a501af149a8484da4db3094b3e6615705b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a90872dbc3062aa1407378e32d3ca286db);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */